/* CF山梨: メンバーカード → プロフィールモーダル（Progressive Enhancement）
   - profile があるカード(.cf-member-card--has-bio)のクリックで <dialog> を開く。
   - 写真+名前は sticky で追従（CSS）、経歴本文だけスクロール。
   - 開く/切り替えのたびに本文を先頭へリセット。
   - 前/次ボタン・←→キーで隣の選手へ移動（端は循環）。
   - JS無効/失敗時でも一覧は通常表示される（動きは上乗せ・前提にしない）。 */
(function () {
  'use strict';

  function setup(root) {
    var modal = root.querySelector('.cf-member-modal');
    if (!modal) return;
    var content = modal.querySelector('.cf-member-modal__content');
    if (!content) return;

    // profile があるカードを順番に集める（前後移動の並び＝この順）
    var cards = [];
    var nodes = root.querySelectorAll('.cf-member-card--has-bio');
    for (var k = 0; k < nodes.length; k++) {
      var tpl = nodes[k].querySelector('.cf-member-card__data');
      var trigger = nodes[k].querySelector('.cf-member-card__trigger');
      if (tpl && trigger) cards.push({ tpl: tpl, trigger: trigger });
    }
    if (!cards.length) return;

    var index = -1;

    function render(i) {
      index = (i % cards.length + cards.length) % cards.length; // 端は循環
      content.innerHTML = '';
      content.appendChild(cards[index].tpl.content.cloneNode(true));
      content.scrollTop = 0; // 開く/切り替えのたびに先頭へ
    }

    function show() {
      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('cf-member-modal-open');
    }

    function close() {
      if (typeof modal.close === 'function') {
        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
      }
      document.documentElement.classList.remove('cf-member-modal-open');
    }

    function openAt(i) {
      render(i);
      show();
      // 表示確定後にもう一度先頭へ（showModal 直後のスクロール残り対策）
      requestAnimationFrame(function () { content.scrollTop = 0; });
    }

    for (var j = 0; j < cards.length; j++) {
      (function (i) {
        cards[i].trigger.addEventListener('click', function () { openAt(i); });
      })(j);
    }

    var prev = modal.querySelector('[data-cf-prev]');
    var next = modal.querySelector('[data-cf-next]');
    if (prev) prev.addEventListener('click', function () { render(index - 1); });
    if (next) next.addEventListener('click', function () { render(index + 1); });

    var closers = modal.querySelectorAll('[data-cf-close]');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', function () { close(); });
    }

    // 暗幕(::backdrop)クリックで閉じる
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    // ←→ で前後の選手へ
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { render(index - 1); }
      else if (e.key === 'ArrowRight') { render(index + 1); }
    });
    // Esc(ネイティブ close)後始末
    modal.addEventListener('close', function () {
      content.innerHTML = '';
      document.documentElement.classList.remove('cf-member-modal-open');
    });
  }

  function init() {
    var lists = document.querySelectorAll('.cf-member-list');
    for (var i = 0; i < lists.length; i++) {
      try {
        setup(lists[i]);
      } catch (e) {
        /* 失敗してもカード一覧は通常表示のまま */
      }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
